import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PedidoService } from 'src/app/services/pedido.service';
import { ModalMensajeComponent } from '../general/modal-mensaje/modal-mensaje.component';

@Component({
  selector: 'app-pago-error',
  templateUrl: './pago-error.component.html',
  styleUrls: ['./pago-error.component.css']
})
export class PagoErrorComponent implements OnInit {

  constructor(
    private router: Router
  ) { }

  ngOnInit() {

  }

  navegar(direccion){
    this.router.navigate([direccion]);
  }
}